import { IOptionResponse } from "./../interfaces/options-response"
import { api } from "../../api"
import { makeOptionsApiEndpoints } from "./endpoints"

const apiEndpoints = makeOptionsApiEndpoints()

export const optionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchOrgOptions: builder.query<IOptionResponse[], string>({
      query: (orgId: string) => apiEndpoints.options(orgId),
      providesTags: ["Options"],
    }),
    fetchOptions: builder.query<IOptionResponse[], void>({
      query: () => apiEndpoints.userOptions(),
      providesTags: ["Options"],
    }),
  }),
})

export const { useFetchOptionsQuery, useFetchOrgOptionsQuery } = optionsApi
